module.exports = __webpack_public_path__ + "static/media/dashboard.1249a7db.svg";